import { IConfigurationRegistry } from "../../../../base/domain/configuration";
import { AuthenticatedService } from "../../../../base/infrastructure";
import { IFormatService } from "../../../domain/developer";
import { IConfiguration } from "../../../domain/configuration";
import { IEditableFormatStructure } from "../../../domain/editableFormat";
import { TranslatorFactory } from "../../editableFormat/ver2/translators";

export class FormatService extends AuthenticatedService implements IFormatService {
  constructor(getToken: () => string, private readonly _configurationRegistry: IConfigurationRegistry<IConfiguration>) {
    super(getToken);
    this._translatorFactory = new TranslatorFactory(this._configurationRegistry);
  }

  private readonly _translatorFactory: TranslatorFactory;

  async loadFormatStructureSource(id: number): Promise<any> {
    const url = "api/format-editor/format/" + id + "/edit";
    const result = await this.get(url);
    return result.data;
  }

  translateFormatStructuteFromSource(source: any): IEditableFormatStructure {
    return this._translatorFactory.create().toFormatStructure(source);
  }

  translateFormatStructuteToSource(format: IEditableFormatStructure, isTemporary: boolean = false): any {
    return this._translatorFactory.create().toFormatObjectBean(format, isTemporary);
  }
}
